import { apiEndpoints } from 'settings/_apiSettings'
import axios from 'settings/axios'

import { Error } from './error.types'

interface IUploadFile {
  uuid: string;
}

interface UploadFilessResponse {
  data: {
    uuid: string;
  };
}

export const uploadFiles = (
  formUuid: string,
  body: FormData
): Promise<IUploadFile> => {
  const endpoint = apiEndpoints.MEDICAL_RECORDS_FORMS_UPLOAD_FILES(formUuid)

  return new Promise<IUploadFile>((resolve, reject) => {
    axios
      .post(endpoint, body)
      .then((response: UploadFilessResponse) =>
        resolve({
          uuid: response.data.uuid,
        } as IUploadFile)
      )
      .catch((error: Error) => {
        reject(error?.response?.status)
      })
  })
}

export const deleteUploadFile = (fileUuid: string): Promise<void> => {
  const endpoint = apiEndpoints.MEDICAL_RECORDS_DELETE_UPLOAD_FILES(fileUuid)
  return new Promise<void>((resolve, reject) => {
    axios
      .delete(endpoint)
      .then(() => resolve())
      .catch((error: Error) => {
        reject(error?.response?.status)
      })
  })
}
